/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterCaratWeight_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuCaratWeight_itemSearch">;
    readonly " $refType": "SbMobileRefineMenuFilterCaratWeight_itemSearch";
};
export type SbMobileRefineMenuFilterCaratWeight_itemSearch$data = SbMobileRefineMenuFilterCaratWeight_itemSearch;
export type SbMobileRefineMenuFilterCaratWeight_itemSearch$key = {
    readonly " $data"?: SbMobileRefineMenuFilterCaratWeight_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterCaratWeight_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterCaratWeight_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'a9ee523adaec7ff728b7f74349aed89c';
export default node;
